import React from "react";
import YesNoColumn from "./YesNoColumn";

const ServiceStatusColumn = ({active}) => <YesNoColumn active={active} activeLabel='Aktywna' inactiveLabel='Nieaktywna'/>

export default ServiceStatusColumn;
